const DAYS = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

export function normalizeOpeningHours(value) {
  const empty = Object.fromEntries(DAYS.map((day) => [day, "Hours unavailable"]));
  if (!value) return { days: empty, status: "unavailable", appears24Hours: false, splitShift: false };
  const raw = typeof value === "string" ? safeJson(value) : value;
  const descriptions = raw?.weekdayDescriptions || raw?.weekday_descriptions;
  if (Array.isArray(descriptions) && descriptions.length) {
    const days = { ...empty };
    descriptions.forEach((description, index) => {
      const text = String(description || "").replace(/^[^:]+:\s*/, "").trim();
      if (DAYS[index]) days[DAYS[index]] = text || "Hours unavailable";
    });
    return summarize(days, raw);
  }
  const periods = Array.isArray(raw?.periods) ? raw.periods : [];
  if (!periods.length) return { days: empty, status: "unavailable", appears24Hours: false, splitShift: false };
  const days = { ...empty };
  const grouped = Object.fromEntries(DAYS.map((day) => [day, []]));
  for (const period of periods) {
    const open = period?.open;
    const close = period?.close;
    if (!open || !DAYS[open.day]) continue;
    if (!close) grouped[DAYS[open.day]].push("Open 24 hours");
    else grouped[DAYS[open.day]].push(`${formatTime(open)}–${formatTime(close)}`);
  }
  for (const day of DAYS) if (grouped[day].length) days[day] = grouped[day].join(", ");
  return summarize(days, raw);
}

export function todayOpeningHours(value, date = new Date()) {
  const normalized = normalizeOpeningHours(value);
  return normalized.days[DAYS[(date.getDay() + 6) % 7]] || "Hours unavailable";
}

function summarize(days, raw) {
  const values = Object.values(days);
  return { days, status: values.some((value) => value !== "Hours unavailable") ? "normalized" : "unavailable", appears24Hours: values.some((value) => /24 hours|24\/7/i.test(value)) || raw?.alwaysOpen === true, splitShift: values.some((value) => value.split(",").length > 1) };
}
function formatTime(value) {
  const hour = Number(value.hour); const minute = Number(value.minute || 0);
  if (!Number.isInteger(hour) || hour < 0 || hour > 23) return "Unknown";
  const suffix = hour >= 12 ? "PM" : "AM"; const displayHour = hour % 12 || 12;
  return `${displayHour}:${String(minute).padStart(2, "0")} ${suffix}`;
}
function safeJson(value) { try { return JSON.parse(value); } catch { return null; } }
export { DAYS };
